const dt = new Date();
const locale = navigator.languages != undefined ? navigator.languages[0] : navigator.language;
const fullMonth = dt.toLocaleDateString(locale, { month: 'long' });
const fullYear = dt.toLocaleDateString(locale, { year: "numeric" });
export default `${fullMonth} ${fullYear}`